import { Icon, IconProps, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';

type LabelDescriptionItemProps = {
  label: string;
  description?: string;
  iconName?: IconProps['name'];
  iconSize?: IconSizeClasses;
};

export function LabelDescriptionItem({
  label,
  description,
  iconName,
  iconSize = IconSizeClasses.Small,
}: LabelDescriptionItemProps): ReactElement {
  return (
    <div className="flex flex__ai--center gap-m">
      {iconName && <Icon name={iconName} size={iconSize} className="m-top-xxs" />}
      <div className="flex flex__dir--column">
        <span className="body-bold">{label}</span>
        {description && <span className="body color-gray-800">{description}</span>}
      </div>
    </div>
  );
}
